import React from "react";

export const SuccessIcon = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="69" height="69" rx="34.5" fill="#6FC56F" fillOpacity="0.1"/>
    <path d="M28.3598 35.0988L34.9291 41.1974L45.4559 29.0153" stroke="#6FC56F" strokeWidth="2"/>
    <rect x="0.5" y="0.5" width="69" height="69" rx="34.5" stroke="#6FC56F"/>
  </svg>
)
